import { Complaint } from '../Complaint'
import { dateToString } from '../../utilities/methods/dateToString'
import { formSchema } from './schema'
import { childSupport } from '../../strings/titles'
import { formatYesNoToTrueFalse } from '../../utilities'
import { routePaths as routes } from '../../utilities/routePaths'
import { withBackButtonProtection } from '../../components/withBackButtonProtection'
import { withDocTitle } from '../../components/withDocTitle'
import withRecaptcha from '../withRecaptcha'

export class ChildSupportComplaint extends Complaint {
  constructor(props) {
    super(props)
    this.complaintType = 'child_support'
    this.schema = formSchema(this.saveFormData)
    this.successURL = routes.childsupport.confirmation
  }

  /*
   * Combine the child support unique data with the common complaint data.
   */
  formatComplaintForRequest(formData) {
    // Process the data unique to this complaint.
    const {
      owe_more_than_minimum_yn,
      amount_owed,
      subject_in_different_location_yn,
      subject_location,
      children,
      court_order_exists_yn,
      case_number,
      court_name,
      court_order_date,
      case_worker_assigned_yn,
      case_worker_first_name,
      case_worker_last_name,
      case_worker_middle_name,
      case_worker_suffix,
      case_worker_phone,
      case_worker_email
    } = formData

    const detail = {
      owe_more_than_minimum: formatYesNoToTrueFalse(owe_more_than_minimum_yn),
      amount_owed,
      subject_in_different_location: formatYesNoToTrueFalse(
        subject_in_different_location_yn
      ),
      subject_location,
      children,
      court_order_exists: formatYesNoToTrueFalse(court_order_exists_yn),
      case_number,
      court_name,
      court_order_date: dateToString(court_order_date),
      case_worker_assigned: formatYesNoToTrueFalse(case_worker_assigned_yn),
      case_worker:
        case_worker_assigned_yn === 'Yes'
          ? {
              first_name: case_worker_first_name,
              last_name: case_worker_last_name,
              middle_name: case_worker_middle_name,
              suffix: case_worker_suffix,
              phone: case_worker_phone,
              email: case_worker_email
            }
          : undefined
    }

    // Return the combined unique data and common data.
    return this.formatCommonComplaintFormData(formData, detail)
  }
}

export default withRecaptcha(
  withBackButtonProtection(withDocTitle(ChildSupportComplaint, childSupport))
)
